import { defineStore } from 'pinia'

export const useChannelsStore = defineStore('channels-store', {
    state: () => ({
        channels: [],
        channel: null,
        loading: false,
        error: null,
        channelEdits: {},
        newChannel: { 
            editing: false,
        },
        recipient: {},
        commLogs: []
    }),
    actions: {
        setRecipient(recipientType, recipientId) {
            this.recipient.type = recipientType
            this.recipient.id = recipientId
        },
        setPreferredChannel(preferredChannelId) {
            this.recipient.preferred_channel_id = preferredChannelId
        },
        async fetchChannels() {
            this.channels = []
            this.loading = true
            try {
                let _channels = await fetch('/api/channels?recipient_type='+ this.recipient.type +'&recipient_id='+ this.recipient.id)
                    .then((response) => response.json())
                this.channels = _channels['data']
                this.channels.forEach((channel) => {
                    let channel_type = channel.channel_type_id == 1 ? 'Phone' : (channel.channel_type_id == 2 ? 'Email' : (channel.channel_type_id == 3 ? 'Address' : 'Unknown'))
                    if (channel_type == 'Address') {
                        let address = JSON.parse(channel.address)
                        this.channelEdits[channel.id] = { 
                            editing: false,
                            channel_type: channel_type,
                            name: channel.name,
                            street1: address.street1,
                            street2: address.street2,
                            city: address.city,
                            zipcode: address.zipcode,
                            is_primary: channel.is_primary,
                            is_bad: channel.is_bad,
                            notes: channel.notes
                        }
                    } else {
                        this.channelEdits[channel.id] = { 
                            editing: false,
                            name: channel.name,
                            channel_type: channel_type,
                            address: channel.address,
                            is_primary: channel.is_primary,
                            is_bad: channel.is_bad,
                            notes: channel.notes
                        }
                    }
                })
            } catch (error) {
                this.error = error
            } finally {
                this.loading = false
            }
        },
        async storeChannel() {
            try {
                let address = null
                if (this.newChannel.channel_type == 'Address') {
                    address = {
                        street1: this.newChannel.street1,
                        street2: this.newChannel.street2 ?? null,
                        city: this.newChannel.city ?? null,
                        zipcode: this.newChannel.zipcode
                    }
                } else {
                    address = this.newChannel.address
                }
                let addChannel = {
                    name: this.newChannel.name,
                    address: address,
                    channel_type_id: this.newChannel.channel_type == 'Phone' ? 1 : (this.newChannel.channel_type == 'Email' ? 2 : (this.newChannel.channel_type == 'Address' ? 3 : null)),
                    is_primary: this.newChannel.is_primary,
                    is_bad: this.newChannel.is_bad,
                    notes: this.newChannel.notes
                }
                await axios.post('/api/channels', { channel: addChannel, recipient_type: this.recipient.type, recipient_id: this.recipient.id })
            } catch (error) {
                this.error = error
            } finally {
                this.newChannel = {}
                this.fetchChannels()
            }
        },
        async updateChannel(channelId) {
            try {
                await axios.put('/api/channels/'+ channelId, { channel: this.channelEdits[channelId] })
            } catch (error) {
                this.error = error
            } finally {
                this.channelEdits[channelId]['editing'] = false
                this.fetchChannels()
            }
        },
        async deleteChannel(channelId) {
            try {
                await axios.delete('/api/channels/'+ channelId)
                    .then((response) => response.json())
            } catch (error) {
                this.error = error
            } finally {
                this.fetchChannels()
            }
        },
        async fetchCommLogs() {
            this.commLogs = []
            try {
                let _commLogs = await fetch('/api/comm-logs?recipient_type='+ this.recipient.type +'&recipient_id='+ this.recipient.id)
                    .then((response) => response.json())
                this.commLogs = _commLogs['data']
            } catch (error) {
                this.error = error
            }
        },
        attachedLogsExist(channelId) {
            if (this.commLogs.length && this.commLogs.find(obj => obj.channel_id == channelId)) {
                return true
            }
            return false
        },
        async editPreferredChannel(channelId) {
            try {
                await axios.put('/api/participants/'+ this.recipient.id +'/channels/'+ channelId + '/update-preferred-channel')
            } catch (error) {
                this.error = error
            } finally {
                this.fetchRecipientPreferredChannel(this.recipient.id)
            }
        },
        async fetchRecipientPreferredChannel(recipientId) {
            try {
                let participant = await fetch('/api/participants/'+ this.recipient.id).then((response) => response.json())
                this.recipient.preferred_channel_id = participant.preferred_channel_id
            } catch (error) {
                this.error = error
            }
        },
        async createCommunicationConsent() {
            this.error = null; // Clear any previous errors
            try {
                const data = await axios.post('/api/tasks/new-comm-consent', { 
                    recipient_type: this.recipient.type, 
                    recipient_id: this.recipient.id 
                }).then((response) => response.data)
                
                window.location.href = "/tasks/" + data.task_id
            } catch (error) {
                if (error.response && error.response.status === 422) {
                    this.error = error.response.data.message
                } else {
                    this.error = 'An unexpected error occurred. Please try again.'
                }
            }
        },
        // async createCommunicationConsent() {
        //     try {
        //         const data = await axios.post('/api/tasks/new-comm-consent', { recipient_type: this.recipient.type, recipient_id: this.recipient.id }).then((response) => response.data )
        //         window.location.href = "/tasks/"+data.task_id
        //     } catch (error) {
        //         this.error = error
        //     }
        // },
    },
})